import { ICategory } from 'api/types/_category';
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import BreadCrumb from 'components/Common/BreadCrumb';
import DropdownOption from 'components/Common/DropdownOption';
import Hashtag from 'components/Common/Hashtag';
import InputsRange from 'components/Common/InputsRange';
import TooltipCustom from 'components/Common/TooltipCustom';
import { useRole } from 'components/Hooks/UserHooks';
import { useFormik } from "formik";
import { AI_MODEL_OPTIONS, SYSTEM_CONFIG_KEY } from 'helpers/constans';
import { isHavePermissionRole, ROLES_FOR_APP } from 'helpers/role';
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Card, CardBody, Col, Container, Input, Label, Modal, ModalBody, ModalHeader, Row, Spinner } from "reactstrap";
import { getAllCategory, getConfiguration, putConfiguration, putConfigurationCategory } from 'store/thunks';
import * as Yup from "yup";


const Configuration = () => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();

  const AI_MODEL_OPTIONS_LANG: any = AI_MODEL_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [categories, setCategories] = useState<ICategory[]>([]);
  const [categoryActive, setCategoryActive] = useState<number>(0);

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleSubmit = async (values: any) => {
    if (isLoading) {
      return;
    }
    setIsOpen((_prev) => true);
  };

  const handleSubmitConfiguration = async (values: any) => {
    try {
      if (isLoading) {
        return;
      }

      setIsLoading((_prev) => true);

      const _data_configs = {
        configs: [
          {
            key: SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_DAILY_SEARCH_VOLUME_FROM,
            value: String(values?.daily_search_volume_from ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_MEDIA_RANK_FROM,
            value: String(values?.media_rank_from ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_MEDIA_RANK_TO,
            value: String(values?.media_rank_to ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_TOTAL_NEWS_PER_DAY,
            value: String(values?.total_news_per_day ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_KEYWORD_EXCLUDE,
            value: JSON.stringify((values?.keywords || [])?.map((k: any) => (k?.text || ''))),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_KEYWORD_EXCLUDE_BODY,
            value: JSON.stringify((values?.body_keywords || [])?.map((k: any) => (k?.text || ''))),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_NEWS_SECTION_RANK_FROM,
            value: String(values?.news_section_rank_from ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_NEWS_SECTION_RANK_TO,
            value: String(values?.news_section_rank_to ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_SOURCE_OLD_PUBLISH_DAYS_FROM,
            value: String(values?.source_old_publish_days_from ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_SOURCE_OLD_PUBLISH_DAYS_TO,
            value: String(values?.source_old_publish_days_to ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_SOURCE_CLUSTER_OLD_PUBLISH_DAYS_FROM,
            value: String(values?.source_cluster_old_publish_days_from ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_SOURCE_CLUSTER_OLD_PUBLISH_DAYS_TO,
            value: String(values?.source_cluster_old_publish_days_to ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_SOURCE_EXPOSURE_PERIOD_FROM,
            value: String(values?.source_exposure_period_from ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_SOURCE_EXPOSURE_PERIOD_TO,
            value: String(values?.source_exposure_period_to ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_SOURCE_MAX_PAGE,
            value: String(values?.source_max_page ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_SOURCE_WORD_COUNT_FROM,
            value: String(values?.source_word_count_from ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_SOURCE_MAX,
            value: String(values?.source_max ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_ALLOW_NEWS_GENERATION,
            value: String(values?.allow_news_generation || '0'),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.NEWS_BOOSTING_ADVERTISEMENT_CHECK_PROMPT,
            value: String(values?.advertisement_check_prompt || ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.NEWS_BOOSTING_FACE_CHECK_PROMPT,
            value: String(values?.face_check_prompt || ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.NEWS_BOOSTING_GENERATE_PROMPT,
            value: String(values?.generate_prompt || ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_TITLE_COUNT,
            value: String(values?.keyword_title_count || '0'),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_BODY_COUNT,
            value: String(values?.keyword_body_count || '0'),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_CONTENT_COUNT,
            value: String(values?.keyword_content_count || '0'),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_ALLOW_REUSE_SOURCE_ARTICLE,
            value: String(values?.allow_reuse_source_article || '0'),
            is_active: 1,
          },
        ]
      };

      // const _data_category_configs = {
      //   keyword_title_count: Number(values?.keyword_title_count),
      //   keyword_body_count: Number(values?.keyword_body_count),
      //   keyword_content_count: Number(values?.keyword_content_count),

      //   sub_keyword_content_count: Number(values?.sub_keyword_content_count),

      //   source_start_minus_day: Number(values?.source_start_minus_day),
      //   source_max: Number(values?.source_max),
      //   source_count: Number(values?.source_count),
      //   total_news_per_day: Number(values?.total_news_per_day),
      //   ai_model: values?.ai_model?.value || AI_MODEL_OPTIONS_LANG[0]?.value,
      //   prompt_format: values?.prompt_format,
      //   allow_reuse_source_article: Number(values?.allow_reuse_source_article),
      //   keyword_excludes: (values?.keyword_excludes || [])?.map((k: any) => (k?.text || '')),

      // };

      // const category_id: number = categories[categoryActive]?.id;
      const [res1]: any = await Promise.all([putConfiguration(_data_configs)]);
      // setCategories((_prev: any) => {
      //   return _prev?.map((_c: any, idx: number) => ((idx === categoryActive) ? ({ ..._c, config: _data_category_configs }) : _c));
      // });
      setIsOpen((_prev) => false);
      setIsLoading((_prev) => false);
      if (res1?.code === 200) {
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
      } else {
        toast(`${res1?.message || res1}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsOpen((_prev) => false);
      setIsLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const validationSchema = Yup.object({
    daily_search_volume_from: Yup.string().nullable(),
    media_rank_from: Yup.string().nullable(),
    media_rank_to: Yup.string().nullable(),
    news_section_rank_from: Yup.string().nullable(),
    news_section_rank_to: Yup.string().nullable(),
    prompt_format: Yup.string().nullable(),
    total_news_per_day: Yup.string().nullable(),
    keyword_title_count: Yup.string().nullable(),
    keyword_body_count: Yup.string().nullable(),
    keyword_content_count: Yup.string().nullable(),
    sub_keyword_content_count: Yup.string().nullable(),
    source_count: Yup.string().nullable(),
    source_start_minus_day: Yup.string().nullable(),
    ai_model: Yup.object().shape({
      label: Yup.string(),
      value: Yup.string(),
    }).nullable(),
    allow_news_generation: Yup.number().nullable(),
    allow_reuse_source_article: Yup.number().nullable(),
    keywords: Yup.array().of(
      Yup.object().shape({
        id: Yup.string(),
        text: Yup.string(),
      })
    ).nullable(),
    body_keywords: Yup.array().of(
      Yup.object().shape({
        id: Yup.string(),
        text: Yup.string(),
      })
    ).nullable(),
    source_old_publish_days_from: Yup.string().nullable(),
    source_old_publish_days_to: Yup.string().nullable(),
    source_cluster_old_publish_days_from: Yup.string().nullable(),
    source_cluster_old_publish_days_to: Yup.string().nullable(),
    source_exposure_period_from: Yup.string().nullable(),
    source_exposure_period_to: Yup.string().nullable(),
    source_max_page: Yup.string().nullable(),
    source_word_count_from: Yup.string().nullable(),
    source_max: Yup.string().nullable(),
  });

  const formik = useFormik({
    initialValues: {
      daily_search_volume_from: '',
      media_rank_from: '',
      media_rank_to: '',
      news_section_rank_from: '',
      news_section_rank_to: '',
      prompt_format: '',
      total_news_per_day: '',
      keyword_title_count: '',
      keyword_body_count: '',
      keyword_content_count: '',
      sub_keyword_content_count: '',
      source_count: '',
      source_start_minus_day: '',
      ai_model: null,
      allow_news_generation: 0,
      allow_reuse_source_article: 0,
      keywords: [],
      body_keywords: [],
      source_old_publish_days_from: '',
      source_old_publish_days_to: '',
      source_cluster_old_publish_days_from: '',
      source_cluster_old_publish_days_to: '',
      source_exposure_period_from: '',
      source_exposure_period_to: '',
      source_max_page: '',
      source_word_count_from: '',
      source_max: '',
      advertisement_check_prompt: '',
      face_check_prompt: '',
      generate_prompt: '',

    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  // const handelChangeCategory = (index: number) => {
  //   setCategoryActive((_prev) => index);
  //   const _category_current = categories[index];
  //   const _category_clone: any = structuredClone(_category_current?.config || {});
  //   delete _category_clone.source_max_page;
  //   delete _category_clone.source_max;
  //   delete _category_clone.source_word_count_from;
  //   delete _category_clone.total_news_per_day;
  //   setValueForm(_category_clone);
  // };

  const setValueForm = (_configs: any) => {

    const _config_prompt_format = _configs?.prompt_format || '';

    const _config_keyword_title_count = _configs?.keyword_title_count;
    const _config_keyword_body_count = _configs?.keyword_body_count;
    const _config_keyword_content_count = _configs?.keyword_content_count;
    const _config_sub_keyword_content_count = _configs?.sub_keyword_content_count;
    const _config_source_count = _configs?.source_count;
    const _config_source_start_minus_day = _configs?.source_start_minus_day;

    const _config_ai_model = AI_MODEL_OPTIONS_LANG?.find((v: any) => String(v?.value) === String(_configs?.ai_model)) || AI_MODEL_OPTIONS_LANG[0];


    const _config_allow_reuse_source_article = _configs?.allow_reuse_source_article;


    const _config_total_news_per_day = _configs?.total_news_per_day;
    const _config_daily_search_volume_from = _configs?.daily_search_volume_from;
    const _config_media_rank_from = _configs?.media_rank_from;
    const _config_media_rank_to = _configs?.media_rank_to;
    const _config_news_section_rank_from = _configs?.news_section_rank_from;
    const _config_news_section_rank_to = _configs?.news_section_rank_to;
    const _config_allow_news_generation = _configs?.allow_news_generation;

    const _config_source_old_publish_days_from = _configs?.source_old_publish_days_from;
    const _config_source_old_publish_days_to = _configs?.source_old_publish_days_to;
    const _config_source_cluster_old_publish_days_from = _configs?.source_cluster_old_publish_days_from;
    const _config_source_cluster_old_publish_days_to = _configs?.source_cluster_old_publish_days_to;
    const _config_source_exposure_period_from = _configs?.source_exposure_period_from;
    const _config_source_exposure_period_to = _configs?.source_exposure_period_to;

    const _config_source_max_page = _configs?.source_max_page;
    const _config_source_word_count_from = _configs?.source_word_count_from;
    const _config_source_max = _configs?.source_max;


    const _config_keywords = _configs?.keywords;
    const _config_body_keywords = _configs?.body_keywords;

    const _config_advertisement_check_prompt = _configs?.advertisement_check_prompt;
    const _config_face_check_prompt = _configs?.face_check_prompt;
    const _config_generate_prompt = _configs?.generate_prompt;

    formik?.setFieldValue('prompt_format', _config_prompt_format);
    formik?.setFieldValue('keyword_title_count', _config_keyword_title_count);
    formik?.setFieldValue('keyword_body_count', _config_keyword_body_count);
    formik?.setFieldValue('keyword_content_count', _config_keyword_content_count);
    formik?.setFieldValue('sub_keyword_content_count', _config_sub_keyword_content_count);
    formik?.setFieldValue('source_count', _config_source_count);
    formik?.setFieldValue('source_max', _config_source_max);
    formik?.setFieldValue('source_start_minus_day', _config_source_start_minus_day);
    formik?.setFieldValue('ai_model', _config_ai_model);
    formik?.setFieldValue('allow_reuse_source_article', Number(_config_allow_reuse_source_article || 0));



    if (_config_total_news_per_day !== null && _config_total_news_per_day !== undefined) {
      formik?.setFieldValue('total_news_per_day', _config_total_news_per_day);
    }

    if (_config_daily_search_volume_from !== null && _config_daily_search_volume_from !== undefined) {
      formik?.setFieldValue('daily_search_volume_from', _config_daily_search_volume_from);
    }
    if (_config_media_rank_from !== null && _config_media_rank_from !== undefined) {
      formik?.setFieldValue('media_rank_from', _config_media_rank_from);
    }
    if (_config_media_rank_to !== null && _config_media_rank_to !== undefined) {
      formik?.setFieldValue('media_rank_to', _config_media_rank_to);
    }
    if (_config_news_section_rank_from !== null && _config_news_section_rank_from !== undefined) {
      formik?.setFieldValue('news_section_rank_from', _config_news_section_rank_from);
    }
    if (_config_news_section_rank_to !== null && _config_news_section_rank_to !== undefined) {
      formik?.setFieldValue('news_section_rank_to', _config_news_section_rank_to);
    }

    if (_config_source_old_publish_days_from !== null && _config_source_old_publish_days_from !== undefined) {
      formik?.setFieldValue('source_old_publish_days_from', _config_source_old_publish_days_from);
    }
    if (_config_source_old_publish_days_to !== null && _config_source_old_publish_days_to !== undefined) {
      formik?.setFieldValue('source_old_publish_days_to', _config_source_old_publish_days_to);
    }
    if (_config_source_cluster_old_publish_days_from !== null && _config_source_cluster_old_publish_days_from !== undefined) {
      formik?.setFieldValue('source_cluster_old_publish_days_from', _config_source_cluster_old_publish_days_from);
    }
    if (_config_source_cluster_old_publish_days_to !== null && _config_source_cluster_old_publish_days_to !== undefined) {
      formik?.setFieldValue('source_cluster_old_publish_days_to', _config_source_cluster_old_publish_days_to);
    }
    if (_config_source_exposure_period_from !== null && _config_source_exposure_period_from !== undefined) {
      formik?.setFieldValue('source_exposure_period_from', _config_source_exposure_period_from);
    }
    if (_config_source_exposure_period_to !== null && _config_source_exposure_period_to !== undefined) {
      formik?.setFieldValue('source_exposure_period_to', _config_source_exposure_period_to);
    }
    if (_config_source_max_page !== null && _config_source_max_page !== undefined) {
      formik?.setFieldValue('source_max_page', Number(_config_source_max_page));
    }
    if (_config_source_word_count_from !== null && _config_source_word_count_from !== undefined) {
      formik?.setFieldValue('source_word_count_from', Number(_config_source_word_count_from));
    }
    if (_config_source_max !== null && _config_source_max !== undefined) {
      formik?.setFieldValue('source_max', Number(_config_source_max));
    }

    if (_config_allow_news_generation !== null && _config_allow_news_generation !== undefined) {
      formik?.setFieldValue('allow_news_generation', Number(_config_allow_news_generation));
    }

    if (_config_keywords !== null && _config_keywords !== undefined) {
      formik?.setFieldValue('keywords', _config_keywords);
    }

    if (_config_body_keywords !== null && _config_body_keywords !== undefined) {
      formik?.setFieldValue('body_keywords', _config_body_keywords);
    }

    if (_config_advertisement_check_prompt !== null && _config_advertisement_check_prompt !== undefined) {
      formik?.setFieldValue('advertisement_check_prompt', _config_advertisement_check_prompt);
    }
    if (_config_face_check_prompt !== null && _config_face_check_prompt !== undefined) {
      formik?.setFieldValue('face_check_prompt', _config_face_check_prompt);
    }
    if (_config_generate_prompt !== null && _config_generate_prompt !== undefined) {
      formik?.setFieldValue('generate_prompt', _config_generate_prompt);
    }

  };

  const handleCallAllOption = async () => {
    try {
      const [res1]: any = await Promise.all([getConfiguration({})]);
      // setCategories((_prev) => res1?.data || []);
      if (res1?.data) {
        const _configs = res1?.data?.list || [];

        const _config_keywords = (_configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_KEYWORD_EXCLUDE)?.value || [])?.map((k: any) => ({
          id: k || '',
          text: k || '',
        })) || [];

        const _config_body_keywords = (_configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_KEYWORD_EXCLUDE_BODY)?.value || [])?.map((k: any) => ({
          id: k || '',
          text: k || '',
        })) || [];

        const _config_allow_news_generation = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_ALLOW_NEWS_GENERATION) || {};

        const _config_daily_search_volume_from = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_DAILY_SEARCH_VOLUME_FROM) || {};

        const _config_total_news_per_day = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_TOTAL_NEWS_PER_DAY) || {};

        const _config_media_rank_from = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_MEDIA_RANK_FROM) || {};
        const _config_media_rank_to = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_MEDIA_RANK_TO) || {};
        const _config_news_section_rank_from = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_NEWS_SECTION_RANK_FROM) || {};
        const _config_news_section_rank_to = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_NEWS_SECTION_RANK_TO) || {};
        const _config_source_old_publish_days_from = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_SOURCE_OLD_PUBLISH_DAYS_FROM) || {};
        const _config_source_old_publish_days_to = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_SOURCE_OLD_PUBLISH_DAYS_TO) || {};
        const _config_source_cluster_old_publish_days_from = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_SOURCE_CLUSTER_OLD_PUBLISH_DAYS_FROM) || {};
        const _config_source_cluster_old_publish_days_to = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_SOURCE_CLUSTER_OLD_PUBLISH_DAYS_TO) || {};
        const _config_source_exposure_period_from = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_SOURCE_EXPOSURE_PERIOD_FROM) || {};
        const _config_source_exposure_period_to = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_SOURCE_EXPOSURE_PERIOD_TO) || {};
        const _config_source_max_page = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_SOURCE_MAX_PAGE) || {};
        const _config_source_word_count_from = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_SOURCE_WORD_COUNT_FROM) || {};
        const _config_source_max = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_SOURCE_MAX) || {};

        const _config_advertisement_check_prompt = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.NEWS_BOOSTING_ADVERTISEMENT_CHECK_PROMPT) || {};
        const _config_face_check_prompt = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.NEWS_BOOSTING_FACE_CHECK_PROMPT) || {};
        const _config_generate_prompt = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.NEWS_BOOSTING_GENERATE_PROMPT) || {};


        const _config_keyword_title_count = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_TITLE_COUNT) || {};
        const _config_keyword_body_count = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_BODY_COUNT) || {};
        const _config_keyword_content_count = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_CONTENT_COUNT) || {};
        const _config_allow_reuse_source_article = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.NEWS_BOOSTING_CREATE_ALLOW_REUSE_SOURCE_ARTICLE) || {};


        setValueForm({
          ...(res1?.data?.[0]?.config || {}),
          total_news_per_day: _config_total_news_per_day?.value,
          daily_search_volume_from: _config_daily_search_volume_from?.value,
          media_rank_from: _config_media_rank_from?.value,
          media_rank_to: _config_media_rank_to?.value,
          news_section_rank_from: _config_news_section_rank_from?.value,
          news_section_rank_to: _config_news_section_rank_to?.value,
          source_old_publish_days_from: _config_source_old_publish_days_from?.value,
          source_old_publish_days_to: _config_source_old_publish_days_to?.value,
          source_cluster_old_publish_days_from: _config_source_cluster_old_publish_days_from?.value,
          source_cluster_old_publish_days_to: _config_source_cluster_old_publish_days_to?.value,
          source_exposure_period_from: _config_source_exposure_period_from?.value,
          source_exposure_period_to: _config_source_exposure_period_to?.value,
          source_max_page: _config_source_max_page?.value,
          source_word_count_from: _config_source_word_count_from?.value,
          allow_news_generation: _config_allow_news_generation?.value,
          source_max: _config_source_max?.value,
          keywords: _config_keywords,
          body_keywords: _config_body_keywords,
          advertisement_check_prompt: _config_advertisement_check_prompt?.value,
          face_check_prompt: _config_face_check_prompt?.value,
          generate_prompt: _config_generate_prompt?.value,
          keyword_title_count: _config_keyword_title_count?.value,
          keyword_body_count: _config_keyword_body_count?.value,
          keyword_content_count: _config_keyword_content_count?.value,
          allow_reuse_source_article: _config_allow_reuse_source_article?.value,
        });
      }
    } catch (error: any) {
      return error;
    }
  };

  useEffect(() => {
    handleCallAllOption();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.title = `${t('Configuration')} - ${t('Boosting News')} | PRESS Ai`;
    document.body.classList.remove('vertical-sidebar-enable');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t('Boosting News')} pageTitle={t('Configuration')} />
          <Row>
            {isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION_BOOSTING_NEWS, userPermissions) && (
              <Col lg={12}>
                <Card id="customerList" style={{ boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)', minHeight: '75dvh' }}>
                  <CardBody className="pt-3 mb-3">
                    <form onSubmit={formik.handleSubmit}>
                      <div style={{ maxWidth: '100%', margin: '0 auto' }}>
                        <Row>
                          <Col md={4} className="px-4">
                            {/* <Row>
                              <div className="position-relative mb-3 mt-1 mt-md-0" style={{ border: '1px dashed var(--vz-primary)', borderRadius: '4px', padding: '10px' }}>
                                <span className="text-primary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: '0px', transform: 'translateY(-50%)' }}>{t('Boosting Keyword')}</span>
                                <Col sm={12} md={12} xl={12} className='mt-2 '>
                                  <Label htmlFor="daily_search_volume_from" className="form-label">{t('Daily Search Volume')} <span className="text-danger"> *</span>
                                    <TooltipCustom
                                      title={t("Only generate news for keywords with a daily search volume above the specified threshold.")}
                                      className="d-inline-block vertical-align-middle ms-1"
                                      style={{ transform: 'translateY(1px)' }}
                                    >
                                      <i className="ri-question-line align-bottom text-secondary" ></i>
                                    </TooltipCustom>
                                  </Label>
                                  <Input
                                    className="form-control"
                                    id="daily_search_volume_from"
                                    name="daily_search_volume_from"
                                    type="text"
                                    value={formik?.values?.daily_search_volume_from ?? ''}
                                    placeholder={t('Daily Search Volume')}
                                    autoComplete='off'
                                    onChange={(event: any) => {
                                      const input = event.target.value;
                                      const onlyNumbers = input.replace(/\D/g, "");
                                      const s = onlyNumbers;
                                      formik.setFieldValue("daily_search_volume_from", s);
                                    }}
                                  />
                                  {formik.touched.daily_search_volume_from && formik.errors.daily_search_volume_from ? (
                                    <div className="text-danger mt-2">{formik.errors.daily_search_volume_from}</div>
                                  ) : null}
                                </Col>

                                <Col sm={12} md={12} xl={12} className='mt-2 '>
                                  <Label htmlFor="media_rank_from" className="form-label">{t('Search Media Ranking')} <span className="text-danger"> *</span>
                                    <TooltipCustom
                                      title={t("Generates news only for keywords matching the search-affiliated media ranking criteria in Naver News search results.")}
                                      className="d-inline-block vertical-align-middle ms-1"
                                      style={{ transform: 'translateY(1px)' }}
                                    >
                                      <i className="ri-question-line align-bottom text-secondary" ></i>
                                    </TooltipCustom>
                                  </Label>
                                  <InputsRange
                                    nameFrom="from"
                                    nameTo="to"
                                    valueFrom={formik?.values?.media_rank_from}
                                    valueTo={formik?.values?.media_rank_to}
                                    placeholderFrom={`${t('Search Media Ranking (Start)')}...`}
                                    placeholderTo={`${t('Search Media Ranking (End)')}...`}
                                    labelFrom={`${t('Search Media Ranking (Start)')}`}
                                    labelTo={`${t('Search Media Ranking (End)')}`}
                                    isTypeNumber={true}
                                    onChangeFrom={(val) => formik.setFieldValue("media_rank_from", val)}
                                    onChangeTo={(val) => formik.setFieldValue("media_rank_to", val)}
                                  />
                                </Col>

                                <Col sm={12} md={12} xl={12} className='mt-2 '>
                                  <Label htmlFor="source_exposure_period" className="form-label">{t('Exposure Period')} <span className="text-danger"> *</span>
                                  </Label>
                                  <InputsRange
                                    nameFrom="from"
                                    nameTo="to"
                                    valueFrom={formik?.values?.source_exposure_period_from}
                                    valueTo={formik?.values?.source_exposure_period_to}
                                    placeholderFrom={`${t('Exposure Period2 (Start)')}...`}
                                    placeholderTo={`${t('Exposure Period2 (End)')}...`}
                                    labelFrom={`${t('Exposure Period2 (Start)')}`}
                                    labelTo={`${t('Exposure Period2 (End)')}`}
                                    isTypeNumber={true}
                                    onChangeFrom={(val) => formik.setFieldValue("source_exposure_period_from", val)}
                                    onChangeTo={(val) => formik.setFieldValue("source_exposure_period_to", val)}
                                  />
                                </Col>

                                <Col sm={12} md={12} xl={12} className='mt-2 '>
                                  <Label htmlFor="daily_search_volume_from" className="form-label">{t('News Section Ranking')} <span className="text-danger"> *</span>
                                    <TooltipCustom
                                      title={t("Generates news only for keywords matching the news section ranking criteria in Naver search results.")}
                                      className="d-inline-block vertical-align-middle ms-1"
                                      style={{ transform: 'translateY(1px)' }}
                                    >
                                      <i className="ri-question-line align-bottom text-secondary" ></i>
                                    </TooltipCustom>
                                  </Label>
                                  <InputsRange
                                    nameFrom="from"
                                    nameTo="to"
                                    valueFrom={formik?.values?.news_section_rank_from}
                                    valueTo={formik?.values?.news_section_rank_to}
                                    placeholderFrom={`${t('News Section Ranking (Start)')}...`}
                                    placeholderTo={`${t('News Section Ranking (End)')}...`}
                                    labelFrom={`${t('News Section Ranking (Start)')}`}
                                    labelTo={`${t('News Section Ranking (End)')}`}
                                    isTypeNumber={true}
                                    onChangeFrom={(val) => formik.setFieldValue("news_section_rank_from", val)}
                                    onChangeTo={(val) => formik.setFieldValue("news_section_rank_to", val)}
                                  />
                                </Col>

                                <Col sm={12} md={12} xl={12} className='mt-3 mb-2 '>
                                  <div className="form-check form-switch mb-0">
                                    <Input className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      id="allow_news_generation"
                                      name="allow_news_generation"
                                      checked={!!formik?.values?.allow_news_generation}
                                      onChange={(event: any) => {
                                        formik.setFieldValue("allow_news_generation", Number(event?.target.checked))
                                      }}
                                    />
                                    <Label className="form-check-label" for="allow_news_generation">{t('News Generation')}</Label>
                                  </div>
                                </Col>
                              </div>
                            </Row> */}
                            <Row>
                              <div className="position-relative mb-3 mt-1 mt-md-0" style={{ border: '1px dashed var(--vz-primary)', borderRadius: '4px', padding: '10px' }}>
                                <span className="text-primary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: '0px', transform: 'translateY(-50%)' }}>{t('Group Source Articles')}
                                  <TooltipCustom
                                    title={t("Conditions for collecting source articles used in news generation.")}
                                    className="d-inline-block vertical-align-middle ms-1"
                                    style={{ transform: 'translateY(1px)' }}
                                  >
                                    <i className="ri-question-line align-bottom text-secondary" ></i>
                                  </TooltipCustom>
                                </span>

                                <Col sm={12} md={12} xl={12} className='mt-2 '>
                                  <Label htmlFor="source_old_publish_days_from" className="form-label">{t('Article Publish Date (Single)')} <span className="text-danger"> *</span>
                                    <TooltipCustom
                                      title={t("Collect articles published within the specified period.")}
                                      className="d-inline-block vertical-align-middle ms-1"
                                      style={{ transform: 'translateY(1px)' }}
                                    >
                                      <i className="ri-question-line align-bottom text-secondary" ></i>
                                    </TooltipCustom>
                                  </Label>
                                  <InputsRange
                                    nameFrom="from"
                                    nameTo="to"
                                    valueFrom={formik?.values?.source_old_publish_days_from}
                                    valueTo={formik?.values?.source_old_publish_days_to}
                                    placeholderFrom={`${t('Article Publish Date (Start)')}...`}
                                    placeholderTo={`${t('Article Publish Date (End)')}...`}
                                    labelFrom={`${t('Article Publish Date (Start)')}`}
                                    labelTo={`${t('Article Publish Date (End)')}`}
                                    isTypeNumber={true}
                                    onChangeFrom={(val) => formik.setFieldValue("source_old_publish_days_from", val)}
                                    onChangeTo={(val) => formik.setFieldValue("source_old_publish_days_to", val)}
                                  />
                                  {/* {formik.touched.daily_search_volume_from && formik.errors.daily_search_volume_from ? (
                                    <div className="text-danger mt-2">{formik.errors.daily_search_volume_from}</div>
                                  ) : null} */}
                                </Col>

                                <Col sm={12} md={12} xl={12} className='mt-2 '>
                                  <Label htmlFor="source_cluster_old_publish_days_from" className="form-label">{t('Article Publish Date (Cluster)')} <span className="text-danger"> *</span>
                                    {/* <TooltipCustom
                                      title={t("Collect articles published within the specified period.")}
                                      className="d-inline-block vertical-align-middle ms-1"
                                      style={{ transform: 'translateY(1px)' }}
                                    >
                                      <i className="ri-question-line align-bottom text-secondary" ></i>
                                    </TooltipCustom> */}
                                  </Label>
                                  <InputsRange
                                    nameFrom="from"
                                    nameTo="to"
                                    valueFrom={formik?.values?.source_cluster_old_publish_days_from}
                                    valueTo={formik?.values?.source_cluster_old_publish_days_to}
                                    placeholderFrom={`${t('Source Cluster (Start)')}...`}
                                    placeholderTo={`${t('Source Cluster (End)')}...`}
                                    labelFrom={`${t('Source Cluster (Start)')}`}
                                    labelTo={`${t('Source Cluster (End)')}`}
                                    isTypeNumber={true}
                                    onChangeFrom={(val) => formik.setFieldValue("source_cluster_old_publish_days_from", val)}
                                    onChangeTo={(val) => formik.setFieldValue("source_cluster_old_publish_days_to", val)}
                                  />
                                  {/* {formik.touched.daily_search_volume_from && formik.errors.daily_search_volume_from ? (
                                    <div className="text-danger mt-2">{formik.errors.daily_search_volume_from}</div>
                                  ) : null} */}
                                </Col>



                                <Col sm={12} md={12} xl={12} className='mt-2 '>
                                  <Label htmlFor="source_max_page" className="form-label">{t('Maximum Search Pages')} <span className="text-danger"> *</span>
                                    <TooltipCustom
                                      title={t("Collect articles up to the specified number of search result pages.")}
                                      className="d-inline-block vertical-align-middle ms-1"
                                      style={{ transform: 'translateY(1px)' }}
                                    >
                                      <i className="ri-question-line align-bottom text-secondary" ></i>
                                    </TooltipCustom>
                                  </Label>
                                  <Input
                                    className="form-control"
                                    id="source_max_page"
                                    name="source_max_page"
                                    type="text"
                                    autoComplete='off'
                                    value={formik?.values?.source_max_page ?? ''}
                                    placeholder={t('Maximum Search Pages')}
                                    onChange={(event: any) => {
                                      const input = event.target.value;
                                      const onlyNumbers = input.replace(/\D/g, "");
                                      const s = onlyNumbers;
                                      formik.setFieldValue("source_max_page", s);
                                    }}
                                  />
                                  {formik.touched.source_max_page && formik.errors.source_max_page ? (
                                    <div className="text-danger mt-2">{formik.errors.source_max_page}</div>
                                  ) : null}
                                </Col>
                                <Col sm={12} md={12} xl={12} className='mt-2  mb-2'>
                                  <Label htmlFor="source_word_count_from" className="form-label">{t('Article Body Word Count')} <span className="text-danger"> *</span>
                                    <TooltipCustom
                                      title={t("Collect only articles where the body text meets the specified word count.")}
                                      className="d-inline-block vertical-align-middle ms-1"
                                      style={{ transform: 'translateY(1px)' }}
                                    >
                                      <i className="ri-question-line align-bottom text-secondary" ></i>
                                    </TooltipCustom>
                                  </Label>
                                  <Input
                                    className="form-control"
                                    id="source_word_count_from"
                                    name="source_word_count_from"
                                    type="text"
                                    autoComplete='off'
                                    value={formik?.values?.source_word_count_from ?? ''}
                                    placeholder={t('Article Body Word Count')}
                                    onChange={(event: any) => {
                                      const input = event.target.value;
                                      const onlyNumbers = input.replace(/\D/g, "");
                                      const s = onlyNumbers;
                                      formik.setFieldValue("source_word_count_from", s);
                                    }}
                                  />
                                  {formik.touched.source_word_count_from && formik.errors.source_word_count_from ? (
                                    <div className="text-danger mt-2">{formik.errors.source_word_count_from}</div>
                                  ) : null}
                                </Col>

                                <Col sm={12} md={12} xl={12} className='mt-2'>
                                  <div style={{ minHeight: '80px' }}>
                                    <label className="form-label">
                                      {t("Exclusion Keywords for Collection")} ({t('Article Title')})
                                    </label>
                                    <TooltipCustom
                                      title={t("When collecting source contents, articles with titles containing the specified keywords will not be collected.")}
                                      className="d-inline-block vertical-align-middle ms-1"
                                      style={{ transform: 'translateY(1px)' }}
                                    >
                                      <i className="ri-question-line align-bottom text-secondary" ></i>
                                    </TooltipCustom>
                                    <Hashtag
                                      name="keywords"
                                      placeholder={`${t("Exclusion Keywords for Collection")} (${t('Article Title')})...`}
                                      suggestions={[]}
                                      initialValue={formik?.values?.keywords || []}
                                      onChangeTag={(event: any) => {
                                        formik.setFieldValue("keywords", event);
                                      }}
                                      idSelected="hashtags-CampaignFormMulti"
                                      maxHashtags={2000}
                                      maxHeight="150px"
                                    />
                                  </div>
                                </Col>
                                <Col sm={12} md={12} xl={12} className='mt-2'>
                                  <div style={{ minHeight: '80px' }}>
                                    <label className="form-label">
                                      {t("Exclusion Keywords for Collection")} ({t('Article Body')})
                                    </label>
                                    <TooltipCustom
                                      title={t("When collecting source contents, articles with bodies containing the specified keywords will not be collected.")}
                                      className="d-inline-block vertical-align-middle ms-1"
                                      style={{ transform: 'translateY(1px)' }}
                                    >
                                      <i className="ri-question-line align-bottom text-secondary" ></i>
                                    </TooltipCustom>
                                    <Hashtag
                                      name="body_keywords"
                                      placeholder={`${t("Exclusion Keywords for Collection")} (${t('Article Body')})...`}
                                      suggestions={[]}
                                      initialValue={formik?.values?.body_keywords || []}
                                      onChangeTag={(event: any) => {
                                        formik.setFieldValue("body_keywords", event);
                                      }}
                                      idSelected="hashtags-CampaignFormMulti"
                                      maxHashtags={2000}
                                      maxHeight="150px"
                                    />
                                  </div>
                                </Col>

                                <Col sm={12} md={12} xl={12} className='mt-2 '>
                                  <Label htmlFor="source_max" className="form-label">{t('Collected News Count')} <span className="text-danger"> *</span>
                                  </Label>
                                  <Input
                                    className="form-control"
                                    id="source_max"
                                    name="source_max"
                                    type="text"
                                    autoComplete='off'
                                    value={formik?.values?.source_max ?? ''}
                                    placeholder={t('Collected News Count')}
                                    onChange={(event: any) => {
                                      const input = event.target.value;
                                      const onlyNumbers = input.replace(/\D/g, "");
                                      const s = onlyNumbers;
                                      formik.setFieldValue("source_max", s);
                                    }}
                                  />
                                  {formik.touched.source_max && formik.errors.source_max ? (
                                    <div className="text-danger mt-2">{formik.errors.source_max}</div>
                                  ) : null}
                                </Col>

                              </div>
                            </Row>
                            {/* <Row>
                              <div className="position-relative mb-3 mt-1 mt-md-0" style={{ border: '1px dashed var(--vz-primary)', borderRadius: '4px', padding: '10px' }}>
                                <span className="text-primary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: '0px', transform: 'translateY(-50%)' }}>{t('Generated Articles')}
                                </span>
                                <Col sm={12} md={12} xl={12} className='mt-2 '>
                                  <Label htmlFor="total_news_per_day" className="form-label">{t('Total News Per Day')} <span className="text-danger"> *</span>
                                    <TooltipCustom
                                      title={t("Sets the maximum number of articles to be generated per day for each keyword.")}
                                      className="d-inline-block vertical-align-middle ms-1"
                                      style={{ transform: 'translateY(1px)' }}
                                    >
                                      <i className="ri-question-line align-bottom text-secondary" ></i>
                                    </TooltipCustom>
                                  </Label>
                                  <Input
                                    className="form-control"
                                    id="total_news_per_day"
                                    name="total_news_per_day"
                                    type="text"
                                    autoComplete='off'
                                    value={formik?.values?.total_news_per_day ?? ''}
                                    placeholder={t('Total News Per Day')}
                                    onChange={(event: any) => {
                                      const input = event.target.value;
                                      const onlyNumbers = input.replace(/\D/g, "");
                                      const s = onlyNumbers;
                                      formik.setFieldValue("total_news_per_day", s);
                                    }}
                                  />
                                  {formik.touched.total_news_per_day && formik.errors.total_news_per_day ? (
                                    <div className="text-danger mt-2">{formik.errors.total_news_per_day}</div>
                                  ) : null}
                                </Col>
                              </div>
                            </Row> */}
                            <Row>
                              <div className="mb-4 position-relative pt-4 pb-3" style={{ border: '1px dashed var(--vz-primary)', borderRadius: '4px', padding: '10px' }}>
                                <div className="mb-3 position-relative" style={{ border: '1px dashed var(--vz-primary)', borderRadius: '4px', padding: '10px' }}>
                                  <span className="text-primary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: '0px', transform: 'translateY(-50%)' }}>{t('Keyword')}</span>
                                  <Col sm={12} md={12} xl={12} className='mt-1 '>
                                    <Label htmlFor="keyword_title_count" className="form-label">{t('Title')} <span className="text-danger"> *</span>
                                      <TooltipCustom
                                        title={t("Sets the number of keyword matches in the title when collecting articles.")}
                                        className="d-inline-block vertical-align-middle ms-1"
                                        style={{ transform: 'translateY(1px)' }}
                                      >
                                        <i className="ri-question-line align-bottom text-secondary" ></i>
                                      </TooltipCustom>
                                    </Label>
                                    <Input
                                      className="form-control"
                                      id="keyword_title_count"
                                      name="keyword_title_count"
                                      type="text"
                                      value={formik?.values?.keyword_title_count ?? ''}
                                      placeholder={t('Title')}
                                      autoComplete='off'
                                      onChange={(event: any) => {
                                        const input = event.target.value;
                                        const onlyNumbers = input.replace(/\D/g, "");
                                        const s = onlyNumbers;
                                        formik.setFieldValue("keyword_title_count", s);
                                      }}
                                    />
                                    {formik.touched.keyword_title_count && formik.errors.keyword_title_count ? (
                                      <div className="text-danger mt-2">{formik.errors.keyword_title_count}</div>
                                    ) : null}
                                  </Col>

                                  <Col sm={12} md={12} xl={12} className='mt-2 '>
                                    <Label htmlFor="keyword_body_count" className="form-label">{t('Body')} <span className="text-danger"> *</span>
                                      <TooltipCustom
                                        title={t("Sets the number of keyword matches in the body when collecting articles.")}
                                        className="d-inline-block vertical-align-middle ms-1"
                                        style={{ transform: 'translateY(1px)' }}
                                      >
                                        <i className="ri-question-line align-bottom text-secondary" ></i>
                                      </TooltipCustom>
                                    </Label>
                                    <Input
                                      className="form-control"
                                      id="keyword_body_count"
                                      name="keyword_body_count"
                                      type="text"
                                      value={formik?.values?.keyword_body_count ?? ''}
                                      placeholder={t('Body')}
                                      autoComplete='off'
                                      onChange={(event: any) => {
                                        const input = event.target.value;
                                        const onlyNumbers = input.replace(/\D/g, "");
                                        const s = onlyNumbers;
                                        formik.setFieldValue("keyword_body_count", s);
                                      }}
                                    />
                                    {formik.touched.keyword_body_count && formik.errors.keyword_body_count ? (
                                      <div className="text-danger mt-2">{formik.errors.keyword_body_count}</div>
                                    ) : null}
                                  </Col>

                                  <Col sm={12} md={12} xl={12} className='mt-2 pb-1'>
                                    <Label htmlFor="keyword_content_count" className="form-label">{t('Title + Body')} <span className="text-danger"> *</span>
                                      <TooltipCustom
                                        title={t("Sets the number of keyword matches in either the title or the body when collecting articles.")}
                                        className="d-inline-block vertical-align-middle ms-1"
                                        style={{ transform: 'translateY(1px)' }}
                                      >
                                        <i className="ri-question-line align-bottom text-secondary" ></i>
                                      </TooltipCustom>
                                    </Label>
                                    <Input
                                      className="form-control"
                                      id="keyword_content_count"
                                      name="keyword_content_count"
                                      type="text"
                                      autoComplete='off'
                                      value={formik?.values?.keyword_content_count ?? ''}
                                      placeholder={t('Title + Body')}
                                      onChange={(event: any) => {
                                        const input = event.target.value;
                                        const onlyNumbers = input.replace(/\D/g, "");
                                        const s = onlyNumbers;
                                        formik.setFieldValue("keyword_content_count", s);
                                      }}
                                    />
                                    {formik.touched.keyword_content_count && formik.errors.keyword_content_count ? (
                                      <div className="text-danger mt-2">{formik.errors.keyword_content_count}</div>
                                    ) : null}
                                  </Col>
                                </div>

                                <Col sm={12} md={12} xl={12} className='mt-3 '>
                                  <div className="form-check form-switch mb-0">
                                    <Input className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      id="allow_reuse_source_article"
                                      name="allow_reuse_source_article"
                                      checked={!!formik?.values?.allow_reuse_source_article}
                                      onChange={(event: any) => formik.setFieldValue("allow_reuse_source_article", Number(event?.target.checked))}
                                    />
                                    <Label className="form-check-label" for="allow_reuse_source_article">{t('Allow reusing the source article for each session generated.')}</Label>
                                  </div>
                                </Col>

                              </div>
                            </Row>
                          </Col>

                          <Col md={8} className="px-4">

                            <Row>
                              <div className="position-relative mb-3 mt-1 mt-md-0" style={{ border: '1px dashed var(--vz-primary)', borderRadius: '4px', padding: '10px' }}>
                                <span className="text-primary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: '0px', transform: 'translateY(-50%)' }}>
                                  {t('Prompts')}
                                </span>
                                <Col sm={12} md={12} xl={12} className='mt-2 '>
                                  <Label htmlFor="generate_prompt" className="form-label">{t('Generate Prompt')} <span className="text-danger"> *</span>
                                  </Label>
                                  <Input
                                    className="form-control"
                                    id="generate_prompt"
                                    name="generate_prompt"
                                    type="textarea"
                                    rows={19}
                                    autoComplete='off'
                                    value={formik?.values?.generate_prompt ?? ''}
                                    placeholder={t('News Boosting Prompt')}
                                    onChange={(event: any) => {
                                      formik.setFieldValue("generate_prompt", event.target.value);
                                    }}
                                  />
                                  {formik.touched.generate_prompt && formik.errors.generate_prompt ? (
                                    <div className="text-danger mt-2">{formik.errors.generate_prompt}</div>
                                  ) : null}
                                </Col>
                                <Col sm={12} md={12} xl={12} className='mt-3'>
                                  <Label htmlFor="advertisement_check_prompt" className="form-label">{t('Advertisement Check Prompt')} <span className="text-danger"> *</span>
                                  </Label>
                                  <Input
                                    className="form-control"
                                    id="advertisement_check_prompt"
                                    name="advertisement_check_prompt"
                                    type="textarea"
                                    rows={20}
                                    autoComplete='off'
                                    value={formik?.values?.advertisement_check_prompt ?? ''}
                                    placeholder={t('Advertisement Check Prompt')}
                                    onChange={(event: any) => {
                                      formik.setFieldValue("advertisement_check_prompt", event.target.value);
                                    }}
                                  />
                                  {formik.touched.advertisement_check_prompt && formik.errors.advertisement_check_prompt ? (
                                    <div className="text-danger mt-2">{formik.errors.advertisement_check_prompt}</div>
                                  ) : null}
                                </Col>
                                <Col sm={12} md={12} xl={12} className='mt-3 mb-2'>
                                  <Label htmlFor="face_check_prompt" className="form-label">{t('Face Check Prompt')} <span className="text-danger"> *</span>
                                  </Label>
                                  <Input
                                    className="form-control"
                                    id="face_check_prompt"
                                    name="face_check_prompt"
                                    type="textarea"
                                    rows={20}
                                    autoComplete='off'
                                    value={formik?.values?.face_check_prompt ?? ''}
                                    placeholder={t('News Boosting Prompt')}
                                    onChange={(event: any) => {
                                      formik.setFieldValue("face_check_prompt", event.target.value);
                                    }}
                                  />
                                  {formik.touched.face_check_prompt && formik.errors.face_check_prompt ? (
                                    <div className="text-danger mt-2">{formik.errors.face_check_prompt}</div>
                                  ) : null}
                                </Col>

                              </div>
                            </Row>
                          </Col>
                          <Col sm={12} md={12} xl={12} className='mt-4 pt-1 text-end'>
                            <button
                              style={{ width: '150px' }}
                              type="submit"
                              disabled={(isLoading)}
                              className="btn btn-primary fs-14 rounded-pill">
                              {<>{t('Button Update')}</>}
                            </button>
                          </Col>
                        </Row>
                      </div>
                    </form>
                  </CardBody>
                </Card>
              </Col>
            )}
          </Row>
        </Container>

        <Modal
          isOpen={!!isOpen}
          centered={true}
          // size="lg"
          toggle={() => setIsOpen(false)}
          keyboard={true}
        >
          <ModalHeader>
            {t('Configuration')}
          </ModalHeader>
          <ModalBody className="">
            <div className="row g-4">
              <Col sm={12}>
                <div className="row g-3">
                  <div className="mt-3 text-center">
                    <h6 className="mb-2 fs-19 text-center mt-1">
                      {t("Are you sure you want to update this?")}
                    </h6>
                    <p className="fs-15 mb-4 d-flex justify-content-center align-items-start align-items-sm-center text-center ">
                      {t('After confirming the update action, the data will be updated. Do you want to proceed with the update action.')}
                    </p>
                    <div className="d-flex gap-3 mt-2 justify-content-center">
                      <button
                        className="btn btn-primary rounded-pill fs-14"
                        type="button"
                        color="light"
                        onClick={() => handleSubmitConfiguration(formik?.values)}
                        style={{ width: '120px' }}
                      >
                        {(isLoading) ? <Spinner size="sm me-2" ></Spinner> : <>{t('Button Update')}</>}
                      </button>
                      <button
                        className="btn btn-secondary rounded-pill fs-14 ms-2"
                        type="button"
                        color="light"
                        onClick={() => setIsOpen(false)}
                        style={{ width: '120px' }}
                      >
                        {t("Button Close")}
                      </button>
                    </div>
                  </div>
                </div>
              </Col>
            </div>
          </ModalBody>
        </Modal >

        <ToastContainer closeButton={false} newestOnTop={false} pauseOnFocusLoss autoClose={2000} limit={2} />

      </div >
    </React.Fragment >
  );
};

export default Configuration;